<form class="gap-lg grid" [formGroup]="form">
  <div hlmField>
    <label hlmFieldLabel for="select-caracteristique">Parent de la sous-caractéristique</label>
    <hlm-select id="select-caracteristique" formControlName="idCaracteristiqueParente">
      <hlm-select-trigger>
        <hlm-select-value />
      </hlm-select-trigger>

      <hlm-select-content>
        @for (caracteristique of caracteristiques(); track caracteristique.id) {
          <hlm-option [value]="caracteristique.id">
            {{ caracteristique.nom }}
          </hlm-option>
        }
      </hlm-select-content>
    </hlm-select>
  </div>

  <div hlmField>
    <label hlmFieldLabel for="input-nom" labelRequired>Nom de la sous-caractéristique</label>
    <input id="input-nom" hlmInput type="text" formControlName="nom" />
    @if (nom.hasError('required')) {
      <hlm-field-error>Merci de renseigner un nom</hlm-field-error>
    }
    @if (nom.hasError('notUnique')) {
      <hlm-field-error>Cette sous-caractéristique existe déjà.</hlm-field-error>
    }
  </div>
</form>
